import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watch, ref, computed, onMounted, PropType } from "vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import SingleSelect from "@/components/ui/dropdowns/single-select.vue";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'number-dropdown',
  props: {
  /**
   * The numeric value bound to `v-model`.
   * Represents the selected or inputted value within the component.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },

  /**
   * The unique identifier or sequence number for the item.
   * Typically used for ordering or referencing specific elements.
   * @type {number}
   * @required
   */
  itemNumber: {
    type: Number,
    required: true,
  },

  /**
   * An additional string appended to the item label.
   * Can be used to provide extra context or formatting.
   * @type {string}
   * @default ''
   */
  itemLabelExtension: {
    type: String,
    default: "",
  },

  /**
   * The label displayed for the control.
   * Used as a descriptive text for the input field.
   * @type {string}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },

  /**
   * Determines whether the control is read-only.
   * If `true`, user input is disabled.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },

  /**
   * Determines whether the control allows zero as a valid value.
   * If `false`, zero may be restricted as input.
   * @type {boolean}
   * @default true
   */
  allowZeroValue: {
    type: Boolean,
    default: true,
  },

  /**
   * A custom initial value for the input field.
   * Typically used when a specific first value needs to be prefilled.
   * @type {string}
   * @default ''
   */
  customFirstValue: {
    type: String,
    default: "",
  },

  /**
   * The width of the field, defined by the `FieldSize` enum.
   * Controls the display size of the input component.
   * @type {FieldSize}
   * @default FieldSize.Large
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Large,
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Number} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const dataSource = ref<IDDescriptionPair[]>([]);

onMounted(() => {
  populateDataSource();
});

const populateDataSource = () => {
  dataSource.value = [];

  for (let i = 0; i <= props.itemNumber; i++) {
    dataSource.value.push({
      id: i,
      description: `${i} ${props.itemLabelExtension}`,
    });
  }

  if (!props.allowZeroValue) {
    dataSource.value.shift();
  }

  if (props.customFirstValue && props.allowZeroValue) {
    dataSource.value[0].description = props.customFirstValue;
  }
};

watch(
  () => props.itemNumber,
  () => {
    populateDataSource();
  },
);

const selectedNumber = computed({
  get: () => props.modelValue,
  set: (value: Number) => emit("update:modelValue", value),
});

return (_ctx: any,_cache: any) => {
  return (dataSource.value.length > 0)
    ? (_openBlock(), _createBlock(SingleSelect, {
        key: 0,
        modelValue: selectedNumber.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedNumber).value = $event)),
        "data-source": dataSource.value,
        width: props.width,
        label: props.label,
        readOnly: props.readOnly,
        "allow-zero-value": props.allowZeroValue
      }, null, 8, ["modelValue", "data-source", "width", "label", "readOnly", "allow-zero-value"]))
    : _createCommentVNode("", true)
}
}

})